import React, { useEffect, useState } from 'react';
import PreviewCommonTable from './PreviewCommonTable';
import { useSelector, useDispatch } from 'react-redux';
import { formatDate, formatModifyDate, mergeTariffDetails } from '../../../components/Common/CommonLogic';
import { sitelogo } from '../../../assets/images';

const PreviewFormat1 = ({ customerInfo, isSingleData }) => {
    const dispatch = useDispatch();
    const quoteData = useSelector((state) => state.instantRate.quote_selected_data);
    const { quote_selected_tenantdata } = useSelector((state) => state.instantRate);
    const mainChargeObj = useSelector((state) => state?.quotation?.mainChargeObj);
    const { searchForm, $instantActiveTab } = useSelector((state) => state?.instantRate);
    const { tenant_info } = useSelector((state) => state?.settings);
    const [mergedQuoteData, setMergedQuoteData] = useState();
    const [mergedComplete, setMergedComplete] = useState(false);
    const [mergedException, setMergedException] = useState(false);

    useEffect(() => {
        console.log(quote_selected_tenantdata,"quote_selected_tenantdata");
        // Always set mergedComplete to true at the end of processing
        const processMerge = async () => {
            try {
                // Check if we have valid data to process
                if (!quoteData || !quoteData[0]) {
                    setMergedException(true);
                    console.log('No quote data available');
                    return;
                }

                // Only merge if not a smart quotation and we have mainChargeObj
                if (quoteData[0].quoteFrom !== "smartQuotation" && mainChargeObj && mainChargeObj.length > 0) {
                    console.log(quoteData[0], "quoteData[0]", mainChargeObj, "mainChargeObj");
                    const mergedArray = mergeTariffDetails(quoteData[0], mainChargeObj);

                    // Only update state if we got valid merged data
                    if (mergedArray && Object.keys(mergedArray).length > 0) {
                        setMergedQuoteData(mergedArray);
                        setMergedException(false);
                        console.log("Merged data processed successfully");
                    } else {
                        setMergedException(true);
                        console.log("Merge operation returned empty or invalid data");
                    }
                } else {
                    setMergedException(true);
                    console.log("No merge needed: smart quotation or no charge objects");
                }
            } catch (error) {
                console.error("Error during merge processing:", error);
            } finally {
                // Always mark as complete regardless of outcome
                setMergedComplete(true);
            }
        };

        processMerge();
    }, [quoteData, mainChargeObj]);

    return (
        <>
            <div className="common_bg_wrap preview_top_details ">
                {/* <p className='mb-2 text-center'><b className='me-1'>Preview Format:</b> 1</p> */}
                <div className="preview_top_details d-flex justify-content-between align-items-center mb-3 mt-4">
                    <div className="left_details">
                        <p className='mb-2'><b className='me-1'>Issue Date:</b>
                            {/* {formatModifyDate(
                                isSingleData === undefined
                                    ? quoteData[0]?.issueData ?? new Date()
                                    : quoteData[0]?.issueData || quote_selected_tenantdata?.createdDate || new Date()
                            )} */}
                            {formatDate(quoteData[0]?.issueData || quote_selected_tenantdata?.createdDate || new Date())}
                        </p>
                        <p><b className='me-1'>Quotation:</b> {quote_selected_tenantdata?.sequenceId}</p>
                    </div>
                    <div className="right_logo">
                        <img src={tenant_info?.logo || sitelogo} alt="logo" onError={e => { e.target.src = sitelogo }} />
                    </div>
                </div>
                <div className="preview_creation_details">
                    <div className="full_wrap white_box">
                        <div className="top_creation_details">
                            <p className="title">Customer Details:</p>
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="details">
                                        <p className='mb-1'>{quoteData[0]?.tenantCustomerName || quoteData[0]?.customerName || customerInfo?.name || searchForm?.customerName?.label || '-'}</p>
                                        <p>{quoteData[0]?.tenantCustomerAddress || quoteData[0]?.customerAddress || customerInfo?.address || searchForm?.customerName?.customerAddress || '-'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="half_wrap mt-1">
                        <div className="half_box white_box">
                            <p className="title">Origin:</p>
                            {/* <div className="details">
                                        <span>Pickup</span>
                                        <p>-</p>
                                    </div> */}
                            <div className="details">
                                <span>Port</span>
                                {/* <p>{searchForm?.location_from?.label || '-'}</p> */}
                                <p>
                                    {
                                        quoteData?.[0]?.quoteFrom === "smartQuotation"
                                            ? quoteData?.[0]?.originName
                                            : isSingleData
                                                ? quoteData?.[0]?.originName
                                                : quoteData?.[0]?.tariffDetails?.[0]?.from || '-'
                                    }
                                </p>

                            </div>
                            <div className="details">
                                <span>Detention free (days) </span>
                                <p>{quoteData?.[0]?.detentionFreeOrg || "-"}</p>
                            </div>
                        </div>
                        <div className="half_box white_box">
                            <p className="title">Destination:</p>
                            <div className="details">
                                <span>Port</span>
                                <p>
                                    {
                                        quoteData?.[0]?.quoteFrom === "smartQuotation"
                                            ? quoteData?.[0]?.destinationName
                                            : isSingleData
                                                ? quoteData?.[0]?.destinationName
                                                : quoteData?.[0]?.tariffDetails?.[quoteData?.[0]?.tariffDetails?.length - 1]?.to || '-'
                                    }
                                </p>
                            </div>
                            <div className="details">
                                <span>Detention free (days) </span>
                                <p>{quoteData?.[0]?.detentionFreeDest || '-'}</p>
                            </div>
                            {/* <div className="details">
                                        <span>Drop</span>
                                        <p>-</p>
                                    </div> */}
                        </div>
                    </div>
                </div>
                <div className="preview_table_wrap">
                    {console.log(searchForm, "searchForm Preview 1")}
                    {console.log(quoteData, "quoteData Preview 1")}
                    <table>
                        <caption><p className='d-flex justify-content-between align-items-center'>Commodities</p></caption>
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th>Package Type</th>
                                <th>Gross Weight</th>
                                <th>Volume(CBM)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Commodities</td>
                                <td>-</td>
                                <td>{$instantActiveTab?.sub === "dom_air" ? searchForm?.shipment_details?.weight || 0 : searchForm?.container_type?.cargo_weight?.value || 0} {$instantActiveTab?.sub === "dom_air" ? searchForm?.shipment_details?.weight_unit : searchForm?.container_type?.cargo_weight?.weight?.value || ''}</td>
                                <td>{$instantActiveTab?.sub === "dom_air" ? searchForm?.shipment_details?.v_weight || 0 : 0}</td>
                                {/* <td>100xBox(s)(40x40x40 CM)</td>
                                        <td>12,000 KG</td>
                                        <td>6.4</td> */}
                            </tr>
                        </tbody>
                    </table>
                </div>

                <PreviewCommonTable />
                {mergedComplete && quoteData?.map((data) => {
                    return data?.quoteFrom === "smartQuotation" ? (
                        <PreviewCommonTable data={data} key={data.quote_id} newData={mainChargeObj.find(obj => obj.id === data.quote_id) || []} tab={$instantActiveTab} />
                    ) : (
                        mergedException ? (
                            <PreviewCommonTable data={data} key={data.quote_id} newData={mainChargeObj.find(obj => obj.id === data.quote_id) || []} tab={$instantActiveTab} />
                        ) : (
                            <PreviewCommonTable data={mergedQuoteData} key={data.quote_id} newData={[]} tab={$instantActiveTab} />
                        )
                    );
                })}


            </div>
        </>
    );
}

export default PreviewFormat1;
